import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const NonRctIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.3874 1.5946L18.3794 8.58665L11.3874 15.5787L11.3874 11.3421L9.08636 11.3421V5.68228L11.3874 5.68227V1.5946Z"
        fill="var(--cdl-chart-yellow-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0861 0.867324C11.3803 0.745468 11.7189 0.812825 11.944 1.03799L18.9361 8.03003C19.2435 8.33748 19.2435 8.83596 18.9361 9.14341L11.944 16.1355C11.7189 16.3606 11.3803 16.428 11.0861 16.3061C10.7919 16.1843 10.6001 15.8972 10.6001 15.5788L10.6001 12.1294L9.08636 12.1294C8.87755 12.1294 8.67731 12.0465 8.52966 11.8988C8.38202 11.7512 8.29907 11.5509 8.29907 11.3421V5.68235C8.29907 5.24755 8.65155 4.89507 9.08635 4.89507L10.6001 4.89506V1.59468C10.6001 1.27625 10.7919 0.98918 11.0861 0.867324ZM12.1746 3.49534V5.68234C12.1746 6.11714 11.8222 6.46962 11.3874 6.46962L9.87363 6.46963V10.5549L11.3873 10.5548C11.5961 10.5548 11.7964 10.6378 11.944 10.7854C12.0917 10.9331 12.1746 11.1333 12.1746 11.3421L12.1746 13.6781L17.266 8.58672L12.1746 3.49534Z"
        fill="var(--cdl-chart-yellow-base)"
      />
      <path
        d="M6.26107 15.5596L12.5765 9.24418L12.5765 7.77284L6.26106 7.47864L1.62064 7.47864L1.62065 10.9576L6.26107 10.9576L6.26107 15.5596Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06396 6.92187C1.21161 6.77423 1.41185 6.69128 1.62065 6.69128L6.26108 6.69129C6.27329 6.69129 6.28551 6.69157 6.29771 6.69214L12.6131 6.98634C13.0333 7.00591 13.3638 7.35221 13.3638 7.77277L13.3638 9.24411C13.3638 9.45291 13.2808 9.65315 13.1332 9.8008L6.81778 16.1162C6.59262 16.3414 6.25399 16.4087 5.95981 16.2869C5.66562 16.165 5.47381 15.878 5.47381 15.5595L5.4738 11.7448L1.62066 11.7448C1.18586 11.7448 0.833387 11.3923 0.833385 10.9575L0.833374 7.47857C0.833373 7.26977 0.916319 7.06952 1.06396 6.92187ZM2.40794 8.26585L2.40794 10.1702L6.26109 10.1702C6.69589 10.1702 7.04836 10.5227 7.04836 10.9575L7.04837 13.6589L11.7892 8.918L11.7892 8.52423L6.24275 8.26585L2.40794 8.26585Z"
        fill="currentColor"
      />
      <path
        d="M6.26106 14.0847L12.5765 7.76929L6.26106 1.45386L6.26106 5.90848H1.62065L1.62064 9.76301H6.26106V14.0847Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95977 0.726577C6.25395 0.604721 6.59258 0.672078 6.81774 0.897238L13.1332 7.21267C13.4406 7.52012 13.4406 8.0186 13.1332 8.32605L6.81774 14.6415C6.59258 14.8666 6.25395 14.934 5.95977 14.8121C5.66558 14.6903 5.47376 14.4032 5.47376 14.0848V10.5504H1.62062C1.41182 10.5504 1.21158 10.4674 1.06393 10.3198C0.916288 10.1721 0.833343 9.97187 0.833344 9.76307L0.83336 5.90855C0.833362 5.47375 1.18584 5.12127 1.62064 5.12127H5.47376L5.47376 1.45393C5.47376 1.1355 5.66558 0.848433 5.95977 0.726577ZM7.04833 3.35459L7.04833 5.90855C7.04833 6.11735 6.96538 6.3176 6.81774 6.46524C6.67009 6.61289 6.46985 6.69583 6.26105 6.69583H2.40792L2.40791 8.9758H6.26104C6.69585 8.9758 7.04832 9.32827 7.04832 9.76308V12.1841L11.4631 7.76936L7.04833 3.35459Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default NonRctIcon;
